import React from "react";
import { Form, Container } from "react-bootstrap";
import { Formik, Field, ErrorMessage, Form as FormikForm } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Layout from "../Components/Layout/Layout";
import { useDispatch } from "react-redux";
import { updatePasswordUser } from "../Redux/Actions/auth";

const validationSchema = Yup.object({
    oldPassword: Yup.string()
        .required("Old password is required")
        .min(6, "Password must be at least 6 characters"),
    newPassword: Yup.string()
        .required("New password is required")
        .min(6, "Password must be at least 6 characters")
        .notOneOf([Yup.ref("oldPassword"), null], "New password must be different from old password"),
    confirmPassword: Yup.string()
        .required("Confirm password is required")
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
});

const ChangePassword = () => {
    const dispatch = useDispatch()

    const initialValues = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {

            let data = { oldPassword: values.oldPassword, newPassword: values.newPassword }
            dispatch(updatePasswordUser(data)).then((res) => {
                if (res?.payload?.statusCode === 200) {
                    toast.success("Password changed successfully");
                    resetForm();
                } else {
                    toast.error(res?.payload?.message)
                }
            })
        } catch (error) {
            toast.error(error.message || "Failed to change password");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Layout>
            <Container fluid>
                <div className="modal-cmn-form-set" style={{ maxWidth: "500px", margin: "90px auto" }}>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ handleSubmit, isSubmitting, errors, isValid }) => (
                            <FormikForm onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="formOldPassword">
                                    <Form.Label>Old Password*</Form.Label>
                                    <Field
                                        name="oldPassword"
                                        type="password"
                                        className="form-control"
                                        placeholder="Enter Old Password"
                                    />
                                    <ErrorMessage
                                        name="oldPassword"
                                        component="div"
                                        className="text-danger"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formNewPassword">
                                    <Form.Label>New Password*</Form.Label>
                                    <Field
                                        name="newPassword"
                                        type="password"
                                        className="form-control"
                                        placeholder="Enter New Password"
                                    />
                                    <ErrorMessage
                                        name="newPassword"
                                        component="div"
                                        className="text-danger"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formConfirmPassword">
                                    <Form.Label>Confirm Password*</Form.Label>
                                    <Field
                                        name="confirmPassword"
                                        type="password"
                                        className="form-control"
                                        placeholder="Confirm New Password"
                                    />
                                    <ErrorMessage
                                        name="confirmPassword"
                                        component="div"
                                        className="text-danger"
                                    />
                                </Form.Group>

                                <div className="home-welcome-txt">
                                    <button
                                        className="white-bg"
                                        type="button"
                                        onClick={() => window.history.back()} // Navigate back as a substitute for Close
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="color-bg"
                                        type="submit"
                                        disabled={isSubmitting || !isValid}
                                    >
                                        {isSubmitting ? "Changing..." : "Change Password"}
                                    </button>
                                </div>
                            </FormikForm>
                        )}
                    </Formik>
                </div>
            </Container>
        </Layout>
    );
};

export default ChangePassword;